// @flow
import * as PublicAccountPagesConstants from "../../Constants/PublicAccountPages/publicAccountPagesConstants";

type StateType = {
  formElements: {
    type: string,
    full_name: string,
    email: string,
    telephone_number: string,
    company_name: string,
    company_desc: string,
    process_requirements: string
  },
  status: {
    isPosting: boolean,
    isCompleted: boolean,
    hasError: boolean
  }
};

type ActionType = {
  type: string,
  payload: Object
};

const initialState = {
  formElements: {
    type: "C",
    full_name: "",
    email: "",
    telephone_number: "",
    company_name: "",
    company_desc: "",
    process_requirements: ""
  },
  status: {
    isPosting: false,
    isCompleted: false,
    hasError: false
  }
};

export default function initialrequest(state: StateType = initialState, action: ActionType) {
  switch (action.type) {
    case PublicAccountPagesConstants.INITIAL_REQUEST_FORM_ELEMENT_VALUE_CHANGE:
      return initialRequestFormElementValueChange(state, action);
    case PublicAccountPagesConstants.INITIAL_REQUEST_FORM_SUBMIT_REQUEST:
      return initialRequestFormSubmitRequest(state);
    case PublicAccountPagesConstants.INITIAL_REQUEST_FORM_SUBMIT_SUCCESS:
      return initialRequestFormSubmitSuccess(state);
    case PublicAccountPagesConstants.INITIAL_REQUEST_FORM_SUBMIT_FAILURE:
      return initialRequestFormSubmitFailure(state);
    case PublicAccountPagesConstants.INITIAL_REQUEST_FORM_ERROR_RELEASE:
      return initialRequestFormErrorRelease(state);
    default: 
      return state;
  }
}

function initialRequestFormElementValueChange(state, action) {
  const { formElement, value } = action.payload;
  return {
    ...state,
    formElements: {
      ...state.formElements,
      [formElement]: value
    }
  }
}

function initialRequestFormSubmitRequest(state) {
  return {
    ...state,
    status: {
      ...state.status,
      isPosting: true
    }
  }
}

function initialRequestFormSubmitSuccess(state) {
  return {
    ...state,
    status: {
      ...state.status,
      isCompleted: true,
      isPosting: false
    }
  }
}

function initialRequestFormSubmitFailure(state) {
  return {
    ...state,
    status: {
      ...state.status,
      hasError: true,
      isPosting: false
    }
  }
}

function initialRequestFormErrorRelease(state) {
  return {
    ...state,
    status: {
      ...state.status,
      hasError: false,
      isCompleted: false,
      isPosting: false
    }
  }
}



// WEBPACK FOOTER //
// ./src/Reducers/PublicAccountPages/initialrequest.js